import topBannerStaticBrand0SubBrand112 from '../../home-page/banner/static-content/0-112-static.html';
import topBannerStaticCOMen from '../../home-page/right-side-banner/static-content/8-8-com-static.html';
import topBannerStaticCOMfi from '../../home-page/right-side-banner/static-content/8-8-fi-static.html';
import topBannerStaticCOMes from '../../home-page/right-side-banner/static-content/8-8-es-static.html';
import topBannerStaticCOMde from '../../home-page/right-side-banner/static-content/8-8-de-static.html';
import topBannerStaticCOMfr from '../../home-page/right-side-banner/static-content/8-8-fr-static.html';
import topBannerStaticCOMpt from '../../home-page/right-side-banner/static-content/8-8-pt-static.html';
import topBannerStaticCOMru from '../../home-page/right-side-banner/static-content/8-8-ru-static.html';
import topBannerStaticCOMuk from '../../home-page/right-side-banner/static-content/8-8-uk-static.html';
import topBannerStaticIT from '../../home-page/right-side-banner/static-content/31-116-it-static.html';
import topBannerStaticES from '../../home-page/right-side-banner/static-content/58-110-es-static.html';
import topBannerStaticRO from '../../home-page/right-side-banner/static-content/76-117-ro-static.html';
import topBannerStaticSE from '../../home-page/right-side-banner/static-content/81-131-se-static.html';
import topBannerStaticSH from '../../home-page/right-side-banner/static-content/83-143-sh-static.html';
import topBannerStaticDK from '../../home-page/right-side-banner/static-content/75-115-dk-static.html';
import topBannerStaticDE from '../../home-page/right-side-banner/static-content/84-136-de-static.html';

export default {
  '0': {
    '112': {
      'homePageBanner': {
        'static': {
          'default': topBannerStaticBrand0SubBrand112
        },
      }
    }
  },
  //sPoker
  '1': {
    '54': {
      'homePageBanner': {
        'static': {
         'default': topBannerStaticBrand0SubBrand112
        }
      }
    }
  },
  //SE
  '81': {
    '131': {
      'homePageBanner': {
        'dynamic': {
          'componentId': 422095,
          'templateId': 389805 // same for all sites/brands/publications
        }
      },
      'homePageRightBanner': {
        'static': {
          'default': topBannerStaticSE
        },
      }
    }
  },
  //COM
  '8': {
    '8': {
      'homePageBanner': {
        'dynamic': {
          'componentId': 454063,
          'templateId': 389805
        }
      },
      'homePageRightBanner': {
        'static': {
          'default': topBannerStaticCOMen,
          'en': topBannerStaticCOMen,
          'fi': topBannerStaticCOMfi,
          'es': topBannerStaticCOMes,
          'de': topBannerStaticCOMde,
          'fr': topBannerStaticCOMfr,
          'pt': topBannerStaticCOMpt,
          'ru': topBannerStaticCOMru,
          'uk': topBannerStaticCOMuk
        },
      }
    }
  },
  //ES
  '58': {
    '110': {
      'homePageBanner': {
        'dynamic': {
          'componentId': 459908,
          'templateId': 389805
        }
      },
      'homePageRightBanner': {
        'static': {
          'default': topBannerStaticES
        },
      }
    }
  },
  //DK
  '75': {
    '115': {
      'homePageBanner': {
        'dynamic': {
          'componentId': 461407,
          'templateId': 389805
        }
      },
      'homePageRightBanner': {
        'static': {
          'default': topBannerStaticDK
        },
      }
    }
  },
  //IT
  '31': {
    '116': {
      'homePageBanner': {
        'dynamic': {
          'componentId': 459913,
          'templateId': 389805
        }
      },
      'homePageRightBanner': {
        'static': {
          'default': topBannerStaticIT
        },
      }
    }
  },
  //RO
  '76': {
    '117': {
      'homePageBanner': {
        'dynamic': {
          'componentId': 434649,
          'templateId': 389805
        }
      },
      'homePageRightBanner': {
        'static': {
          'default': topBannerStaticRO
        },
      }
    }
  },
  //SH
  '83': {
    '134': {
      'homePageBanner': {
        'dynamic': {
          'componentId': 447522,
          'templateId': 389805
        }
      },
      'homePageRightBanner': {
        'static': {
          'default': topBannerStaticSH
        },
      }
    }
  },
  //DE
  '84': {
    '136': {
      'homePageBanner': {
        'dynamic': {
          'componentId': 447522, // [TBD 84]: update value
          'templateId': 389805 // [TBD 84]: update value
        }
      },
      'homePageRightBanner': {
        'static': {
          'default': topBannerStaticDE
        },
      }
    }
  },
};

